import Splide from '@splidejs/splide';

if (document.querySelector('#Carousel')) {
  var carousel = new Splide( '#Carousel', {
    arrows: false,
    speed: 400,
    autoplay: true,
    interval: 5000, // sync with css pagination transition at splide.sccs!
    type   : 'loop',
    pauseOnHover: false,
    pauseOnFocus: false,
    perPage: 1,
    perMove: 1,
    gap: 0,
    focus: 1
  } )

  // trigged first pagination button transition
  carousel.on( 'mounted', function () {
    carousel.root.querySelector('button.is-active').classList.remove('is-active')

    setTimeout(() => {
      carousel.root.querySelector('.splide__pagination li:first-child button').classList.add('is-active')
    }, 10);
  } );

  carousel.mount();
}

if (document.querySelector('#Slider')) {
  var slider = new Splide( '#Slider', {
    pagination: true,
    arrows: false,
    type   : 'loop',
    perPage: 1,
    perMove: 1,
    padding: '6rem',
    fixedWidth: '960px',
    gap: 120,
    focus: 'center',
    speed: 800,
    classes: {
      pagination: 'splide__pagination animate',
    },
    breakpoints: {
            1200: {
             fixedWidth: '480px',
            },
            767: {
             fixedWidth: '300px',
             pagination: false,
             arrows: true,
            },
          },
  } )

  const arrows = document.querySelectorAll('.js-SliderNext');

  arrows.forEach(el => {
    el.addEventListener('click', (e) => {
      slider.go( '>' );

      e.preventDefault()
    })
  })

  slider.on( 'pagination:mounted', function ( data ) {
    const el = document.querySelector('#Slider')
    const titles = JSON.parse(el.getAttribute('data-titles'))

    data.list.classList.add( 'splide__pagination--custom' );

    data.items.forEach( function ( item ) {
      item.button.textContent = String( titles[item.page] );
    } );
  } );

  slider.mount();
}
